import React from 'react';
import Navigation from '../components/Navigation';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const Contact = () => {
    return (
        <div className='contact'>
            <Navigation/>
            <div className="contactContent">
                <div className="header"></div>
                <div className="contactBox">
                    <h1>Contactez-moi</h1>
                    <ul>
                        <li>
                            <i className='fas fa-map-marker-alt'></i>
                            <span>Paris</span>
                        </li>
                        <li>
                            <i className='fas fa-mobile-alt'></i>
                            <CopyToClipboard text="0645118290">
                                <span className='clickInput' onClick={() =>{
                                alert('Téléphone copié !');}}>06 45 11 82 90 </ span>
                            </CopyToClipboard>
                        </li>
                        <li>
                            <i className='far fa-envelope'></i>
                            <CopyToClipboard text="cotardyann@orange.fr">
                                <span className='clickInput' onClick={() =>{
                                alert('Email copié !');}}>cotardyann@orange.fr </span>
                            </CopyToClipboard>
                        </li>
                    </ul>
            </div>
            <div className="socialNetwork">
                <ul>
                    <a href="https://www.linkedin.com/in/yann-cotard?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BtWq2WlW2QKavN%2B5RyMmTpQ%3D%3D" target='_blank' rel='noopener noreferrer'>
                        <h4>LinkedIn</h4>
                        <i className='fab fa-linkedin'></i>
                    </a>
                    <a href="https://github.com/Yann6666" target='_blank' rel='noopener noreferrer'>
                        <h4>Github</h4>
                        <i className='fab fa-github'></i>
                    </a>
                    <a href="https://codepen.io/your-work" target='_blank' rel='noopener noreferrer'>
                        <h4>CodePen</h4>
                        <i className='fab fa-codepen'></i>
                    </a>
                </ul>
            </div>
            </div>
        </div>
    );
};

export default Contact;